// Piwik 已下线，保留空 push 方法避免 window._paq.push() 报错
window._paq = { push: function() {} };

import './styles/index.less';
// import axios from 'axios';
import qs from 'qs';
import wx from 'weixin-js-sdk';
import API from './api';

const downloadAndroid = document.querySelector('#download_android');
const downloadAndroidM = document.querySelector('#download_android_m');
const downloadIos = document.querySelector('#download_ios');
const downloadIosM = document.querySelector('#download_ios_m');
const dialogMode = document.querySelector('#dialog_mode');
const isWX = /MicroMessenger/i.test(navigator.userAgent);

// 应用市场H5地址
const DEFAULT_MARKET_URL = 'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=2179749';
// 应用包名
const APP_PACKAGE_NAME = 'cmt.chinaway.com.lite';

// 判断设备类型
function getDeviceType() {
  const ua = navigator.userAgent.toLowerCase();

  // 华为设备检测
  if (
    /huawei|hwi-|hwr-|eva-|vie-|frd-|che|h60-|wlz-|pra-|bnd-|jsn-|ine-|lya-|ele-|dra-|vog-|ana-|emui|harmonyos|hmos/i.test(
      ua,
    )
  ) {
    return 'huawei';
  }
  // OPPO设备检测 (包括 Realme 和 OnePlus 在 ColorOS 基础上的变体)
  // 注意：OnePlus 转向 ColorOS 后，部分机型可能被识别为 OPPO。单独识别 OnePlus 较复杂。
  else if (
    /oppo|realme|rmx|r[79]|r11|r15|r17|a[579]|f[1359]|f7|f11|reno|find|k[135]|y\d+|padm|pbdm|pb[bcet]m|pb[be]t|pc[adet]m|pcat|pcet|pch[mt]|pd[cnpv]m|paf[mt]|pcr[mr]|x90[07][70]|coloros|pg[a-z]m|pe[a-z]m|cph\d+|op\d+|pg[a-z]{2}\d+/i.test(
      ua,
    )
  ) {
    return 'oppo';
  }
  // 小米设备检测
  else if (
    /xiaomi|mi[ -]|mix|redmi|poco|hm note|hm \d|m2|miui|mi note|mi max|mi pad|mi \d+|201481[1-9]|201482[01]|201491[01]|2015(015|022|501|628)/i.test(
      ua,
    )
  ) {
    return 'xiaomi';
  }
  // vivo设备检测
  else if (
    /vivo|x[2379]0|x[279]|x50|x60|x70|x80|x90|y\d+|s[15-79]|z[135]|nex|iqoo|pd1510|funtouch|origin os/i.test(ua)
  ) {
    return 'vivo';
  } else {
    return 'unknown';
  }
}

// 获取应用市场schema
function getMarketSchema() {
  const deviceType = getDeviceType();
  switch (deviceType) {
    case 'huawei':
      return `appmarket://details?id=${APP_PACKAGE_NAME}`;
    case 'oppo':
      return `oppomarket://details?packagename=${APP_PACKAGE_NAME}`;
    case 'xiaomi':
      return `mimarket://details?id=${APP_PACKAGE_NAME}`;
    case 'vivo':
      return `vivomarket://details?id=${APP_PACKAGE_NAME}`;
    default:
      return null;
  }
}

// 尝试打开应用市场
function openAppMarket() {
  const schema = getMarketSchema();
  if (schema) {
    // 尝试打开应用市场
    const openTime = Date.now();
    const ifr = document.createElement('iframe');
    ifr.src = schema;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);

    // 检测是否成功跳转
    setTimeout(() => {
      document.body.removeChild(ifr);
      // 如果页面长时间没有跳转，则打开默认H5地址
      if (Date.now() - openTime > 2000) {
        window.location.href = DEFAULT_MARKET_URL;
      }
    }, 1000);
  } else {
    // 无法识别机型，直接打开默认H5地址
    window.location.href = DEFAULT_MARKET_URL;
  }
}

// API.getConfig({ path: 'sxbSrc' }).then(data => {
//   if (data) {
//     downloadAndroid.setAttribute('href', data);
//     downloadAndroidM.setAttribute('href', data);

//     // if (!isWX && window.device.android()) {
//     //   location.href = data;
//     // }
//   }
// });

if (isWX) {
  API.getSignature().then(({ appId, nonceStr, timestamp, signature }) => {
    wx.config({
      debug: false,
      appId,
      nonceStr,
      timestamp,
      signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
        'scanQRCode',
      ],
    });

    wx.ready(() => {
      const title = '找好活、结算快，就用司小宝！';
      const desc = '货车司机的贴心小宝贝，接活发车结运费，老司机都在用！';
      const link = `${location.origin}/app/ntocc-driver-app/driverbaby.html`;
      const imgUrl = `${location.origin}/app/ntocc-driver-app/favicon.png`;

      wx.updateAppMessageShareData({ title, desc, link, imgUrl });
      wx.updateTimelineShareData({ title, link, imgUrl });
      wx.onMenuShareAppMessage({ title, desc, link, imgUrl });
      wx.onMenuShareTimeline({ title, link, imgUrl });
    });
  });
}

window._paq.push(['setDocumentTitle', '司小宝主页']);
window._paq.push(['setCustomUrl', window.location.href]);
window._paq.push(['trackPageView']);

downloadIos.onclick = downloadIosM.onclick = () => {
  window._paq.push(['trackEvent', '司小宝主页', '下载ios']);
};

downloadAndroid.onclick = () => {
  window._paq.push(['trackEvent', '司小宝主页', '下载android']);
  if (isWX) {
    dialogMode.style.display = 'block';
    return false;
  }
  window.location.href = DEFAULT_MARKET_URL;
};

downloadAndroidM.onclick = e => {
  window._paq.push(['trackEvent', '司小宝主页', '下载android']);
  if (isWX) {
    dialogMode.style.display = 'block';
    return false;
  }

  // 安卓设备时，尝试跳转到应用市场
  if (window.device && window.device.android()) {
    e.preventDefault();
    openAppMarket();
    return false;
  }
};

dialogMode.onclick = () => {
  dialogMode.style.display = 'none';
};

function schemeJump() {
  const { page, orderId, orderType } = qs.parse(location.search.substring(1));

  switch (page) {
    case 'my':
      window.location.href = 'driverbaby://home?tab=my';
      break;
    case 'accountDetail':
      window.location.href = `driverbaby://account/detail?orderId=${orderId}&orderType=${orderType}`;
      break;
    case 'waybillChecklist':
      window.location.href = 'driverbaby://waybill/checklist';
      break;
    default:
      window.location.href = 'driverbaby://';
      break;
  }
}

schemeJump();
